import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/zengdai/Workspace/vimwiki/Projects/Blogger/blogv3/src/components/posts-layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`This function should be redesigned to be e.g. taking lambda or programmable 😆...`}</p>
    <h1>{`Preword`}</h1>
    <p>{`To understand blend func or op in graphics API, the best place to go is this `}<a parentName="p" {...{
        "href": "https://www.andersriggelsen.dk/glblendfunc.php"
      }}>{`website`}</a>{`.`}</p>
    <h1>{`Blend Color`}</h1>
    <p>{`I think these things should be move into the effect file.`}</p>
    <p>{`RenderTargetBlend(SetRenderState)`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "text"
    }}><pre parentName="div" {...{
        "className": "language-text"
      }}><code parentName="pre" {...{
          "className": "language-text"
        }}>{`resultcolor = ((Srcblend)*Scrcolor) BlendOp ((Destblend)*Destcolor)

alphacolor = (SrcblendAlpha*Scralpha) AlphaOp (DestblendAlpha*Destalpha)`}</code></pre></div>
    <p>{`Carefully design your render parameter, you can set a constant blend factor. When D3DRS_SEPARATEALPHABLENDENABLE is set to FALSE (which is the default condition), the render target blending factors and operations applied to alpha are the same as those defined for blending color channels. Be sure to enable D3DRS_ALPHABLEND to tell the pipeline that alpha blending is needed.`}</p>
    <p>{`TextureBlend(SetTextureStageState)`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "text"
    }}><pre parentName="div" {...{
        "className": "language-text"
      }}><code parentName="pre" {...{
          "className": "language-text"
        }}>{`resultofStage = BlendOp(colorarg1,colorarg2,…..)

resultalphaofStage = AlphaBlendOp(alphaarg1,alphaarg2,…..)`}</code></pre></div>
    <p>{`Notice that if you don’t care about your vertex color when using texture in Fixed Function, dx will give you a random results.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      